import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { axiosInstance } from '../App';
import AuthLayout from '../components/auth/AuthLayout';
import { readSsoCode, SSO_VERIFIER_KEY } from '../lib/ssoCode';

// The identity provider sends people back here with a one-time code in the URL fragment,
// which never reaches a server log. Swap it for a session, then clear it from history.
const SsoComplete = ({ setUser }) => {
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const code = readSsoCode(window.location.hash);
    window.history.replaceState(null, '', window.location.pathname);
    const verifier = sessionStorage.getItem(SSO_VERIFIER_KEY) || '';
    sessionStorage.removeItem(SSO_VERIFIER_KEY);
    if (!code || !verifier) { setFailed(true); return; }
    axiosInstance.post('/auth/sso/exchange', { code, verifier })
      .then(({ data }) => {
        localStorage.setItem('token', data.token);
        setUser(data.user);
        navigate(data.return_to || '/', { replace: true });
      })
      .catch(() => setFailed(true));
  }, [navigate, setUser]);

  return (
    <AuthLayout>
      <div className="enterprise-auth-card" aria-live="polite">
        <div className="enterprise-auth-step">
          <p className="enterprise-auth-kicker">Organisation sign-in</p>
          <h2>{failed ? 'Sign-in did not finish' : 'Signing you in…'}</h2>
          {failed && <>
            <p className="enterprise-auth-error" role="alert">Your sign-in expired or was already used. Start again.</p>
            <button type="button" className="enterprise-auth-primary" onClick={() => navigate('/auth', { replace: true })}>Back to sign in</button>
          </>}
        </div>
      </div>
    </AuthLayout>
  );
};

export default SsoComplete;
